/**
 * External dependencies
 */
import { get } from 'lodash';

export default (state, id) => get(state, ['dashboardLayouts', 'items', id], null);
